import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN, TINY_MARGIN } from '../../theme';

const useStyles = (isDark) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 10,
        background: isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
        overflow: 'hidden',
      },
      bottom: {
        position: 'relative',
        width: '100%',
        marginTop: 'auto',
        padding: `0 12px 12px`,
        boxSizing: 'border-box',
        [theme.breakpoints.up('md')]: {
          padding: `0 ${SMALL_MARGIN}px ${SMALL_MARGIN}px`,
        },
      },
      title: {
        marginBottom: TINY_MARGIN,
      },
      jobTitle: {
        color: colorsPalette.gray,
      },
      link: {
        marginTop: TINY_MARGIN,
        display: 'flex',
        alignItems: 'center',
      },
      image: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
      },
      imageWrapper: {
        position: 'relative',
        height: 0,
        flexGrow: 1,
        marginBottom: -SMALL_MARGIN,
        background: 'linear-gradient(24.01deg, rgba(104, 105, 237, 0.33) 27.74%, rgba(49, 40, 82, 0.33) 83.06%)',
        '&:after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '50%',
          background: `linear-gradient(0deg, ${
            isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary
          } 0%, ${alpha(
            isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
            0.9,
          )} 17.24%, ${alpha(
            isDark ? colorsPalette.blueDark : colorsPalette.blackSecondary,
            0,
          )} 100%);`,
        },
      },
      icon: {
        marginRight: 6,
        width: 16,
      },
    }),
  );

export default useStyles;
